import { http, authHeader } from '@/http-commons';

class AsistenciaDataService {
    create( asistencias ){
        return http.post('api/v1/asistencia/create', asistencias, { headers: authHeader()});
    }
    table( params ){
        return http.get('api/v1/asistencia/table', { params, headers: authHeader() });
    }
    downloadExcelByDateRange( params ){
        return http.get(`api/v1/asistencia/downloadExcelByDateRange/${params.startDate}/${params.endDate}`, { params: { employeeName: params.employeeName, soloSinRaya: params.soloSinRaya }, headers: authHeader(), responseType: 'blob' });
    }
    downloadPdfByDateRange( params ){
        return http.get(`api/v1/asistencia/downloadPdfByDateRange/${params.startDate}/${params.endDate}`, { params: { employeeName: params.employeeName, soloSinRaya: params.soloSinRaya }, headers: authHeader(), responseType: 'blob' });
    }
    byRange( startDate, endDate ){
        return http.get(`api/v1/asistencia/byRange/${startDate}/${endDate}`, { headers: authHeader() });
    }
    delete( asistenciaId ){
        return http.delete(`api/v1/asistencia/delete/${asistenciaId}`, { headers: authHeader() });
    }
}
export default new AsistenciaDataService();